
import { getAuthService } from '../../apps/auth/service'
import { Component, Vue } from 'vue-property-decorator'
import { AuthMachineInterpreter } from '../../apps/auth/authMachine'

@Component
export default class FacebookLoginButton extends Vue {
  authMachine: AuthMachineInterpreter

  async mounted() {
    this.authMachine = await getAuthService()
    // @ts-ignore
    window.fbAsyncInit = () => {
      window.FB.init({
        appId: this.$config.public.facebookApiKey,
        cookie: true,
        xfbml: true,
        version: 'v5.0',
      })
    }
    this.$loadScript('//connect.facebook.net/en_GB/all.js', 'FBLogin')
  }

  startLogin() {
    window.FB.getLoginStatus((response) => {
      this.isAlreadyLoggedIn(response) && response.authResponse?.accessToken
        ? this.authByAccessToken(response.authResponse.accessToken)
        : this.logInFacebookGuest()
    })
  }

  private isAlreadyLoggedIn(response: any) {
    return response.status === 'connected'
  }

  private logInFacebookGuest() {
    window.FB.login(
      (response) => {
        if (
          this.isAlreadyLoggedIn(response) &&
          response.authResponse?.accessToken
        ) {
          this.authByAccessToken(response.authResponse.accessToken)
        }
      },
      { scope: 'email' },
    )
  }

  private authByAccessToken(token: string) {
    this.authMachine.send('LOG_IN_FACEBOOK', { token })
  }
}
